<div class="card">
    <div class="card-header">
        <h3>Reject Logistic Partner Account</h3>
    </div>
    <div class="card-body">
        <form [formGroup]="rejectForm" (ngSubmit)="onSubmit()">
            <div class="mb-3">
                <label for="reason" class="form-label">Reason for Rejection *</label>
                <textarea
                    id="reason"
                    class="form-control"
                    formControlName="reason"
                    rows="5"
                    [ngClass]="{ 'is-invalid': submitted && f['reason'].errors }">
                </textarea>
                <div *ngIf="submitted && f['reason'].errors" class="invalid-feedback">
                    <div *ngIf="f['reason'].errors['required']">Reason is required</div>
                    <div *ngIf="f['reason'].errors['minlength']">Reason must be at least 10 characters</div>
                    <div *ngIf="f['reason'].errors['maxlength']">Reason must not exceed 500 characters</div>
                </div>
            </div>

            <div class="d-flex gap-2">
                <button type="button" class="btn btn-secondary" (click)="onCancel()">
                    Cancel
                </button>
                <button type="submit" class="btn btn-danger">
                    Confirm Rejection
                </button>
            </div>
        </form>
    </div>
</div>
